
// import React, { useState, useEffect } from "react";
// import DataTable from "./DataTable";
// import {
//   OpenFolderIcon,
//   SelectedFolderIcon,
//   ConflictsIcon,
//   GapIcon,
//   StaleAssetIcon,
//   ArrowIcon,
// } from "./Icons";
// import api from "../../chat/api";

// const AllSources = ({
//   contracts,
//   folders,
//   selectedFolderId,
//   setSelectedFolderId,
//   sortedFolders,
//   openCreateFolderModal,
//   selectedContracts,
//   getSelectedFilesCount,
//   hasSelectedFiles,
//   handleMoveToFolder,
//   handleSingleMoveToFolder,
//   handleBulkDelete,
//   handleCancel,
//   displayedFiles,
//   loading,
//   isAllChecked,
//   handleSelectAll,
//   handleCheckboxChange,
//   getFileIcon,
//   removeFileExtension,
//   darkenColor,
//   openTagModalFor,
//   formatDate,
//   toggleActionMenu,
//   isActionMenuOpen,
//   setIsActionMenuOpen,
//   actionMenuPosition,
//   actionMenuRefs,
//   setSelectedFilePreview,
//   handleRenameClick,
//   handleDownload,
//   handleDelete,
//   handleViewAndIngest,
//   columnPreferences,
// }) => {
//   const [isSuggestedOpen, setIsSuggestedOpen] = useState(true);
//   const [isManualOpen, setIsManualOpen] = useState(true);
//   const [conflictsCount, setConflictsCount] = useState(0);

//   useEffect(() => {
//     const fetchConflicts = async () => {
//       try {
//         const response = await api.get("/api/v1/rfp/knowledge-base/conflicts/");
//         // Extracting the count safely (handles both { count: X } object and array responses)
//         const count =
//           response.data?.count !== undefined
//             ? response.data.count
//             : Array.isArray(response.data)
//             ? response.data.length
//             : 0;

//         setConflictsCount(count);
//       } catch (error) {
//         console.error("Failed to fetch conflicts:", error);
//       }
//     };

//     fetchConflicts();
//   }, []);

//   // CHANGED HERE: Chained .sort() to order by updated_at in descending order
//   const suggestedFolders = sortedFolders
//     .filter((f) => f.is_default)
//     .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

//   const manualFolders = sortedFolders
//     .filter((f) => !f.is_default)
//     .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

//   // Find the selected folder name to display in the path
//   const selectedFolderName = selectedFolderId
//     ? sortedFolders.find((f) => f.id === selectedFolderId)?.name
//     : "";

//   return (
//     <div className="flex min-h-0 w-full bg-white">
//       {/* Left Sidebar Pane */}
//       <div className="w-[280px] border-r h-[calc(100vh-150px)] rounded-b-md border-b bg-[#FAFAFA] border-[#E5E7EB] flex flex-col pt-4 pb-0 flex-shrink-0">
//         <div className="px-3 mb-4 flex-shrink-0">
//           <div
//             onClick={() => setSelectedFolderId(null)}
//             className={`flex items-center justify-between px-3 py-2 rounded-md cursor-pointer transition-colors ${
//               selectedFolderId === null
//                 ? "bg-[#8B55DD1F] text-[#8B55DD]"
//                 : "text-[#1A1A1ACC] hover:bg-gray-100"
//             }`}
//           >
//             <span className="font-outfit text-[14px] font-normal  flex-1 truncate">
//               All Files
//             </span>
//             <span className="flex-shrink-0 font-medium text-[12px] opacity-70 ml-2">
//               ({contracts.length})
//             </span>
//             {selectedFolderId === null && <SelectedFolderIcon />}
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto custom-scrollbar pb-5">
//           {loading ? (
//             <div className="flex flex-col items-center justify-center h-32 mt-4">
//               <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#A259FF] mb-3"></div>
//               <span className="text-[#52525B] font-outfit text-[13px] font-medium">
//                 Fetching your folders...
//               </span>
//             </div>
//           ) : (
//             <div className="flex flex-col gap-4">
//               <div className="flex flex-col">
//                 <div
//                   className="flex items-center justify-between px-6 mb-2 group flex-shrink-0 cursor-pointer"
//                   onClick={() => setIsSuggestedOpen(!isSuggestedOpen)}
//                 >
//                   <span className="text-[#808080] font-outfit text-[13px] font-medium uppercase tracking-wider">
//                     Suggested Folders
//                   </span>
//                   <button className="text-[#A259FF] hover:text-[#8B55DD] transition-colors rounded p-0.5">
//                     <svg
//                       className={`w-4 h-4 transform transition-transform ${
//                         isSuggestedOpen ? "rotate-180" : ""
//                       }`}
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M19 9l-7 7-7-7"
//                       />
//                     </svg>
//                   </button>
//                 </div>

//                 {isSuggestedOpen && (
//                   <div className="flex flex-col gap-1">
//                     {suggestedFolders.map((f) => {
//                       const docCount =
//                         f.documents?.length || f.document_count || 0;
//                       return (
//                         <div
//                           key={f.id}
//                           onClick={() => setSelectedFolderId(f.id)}
//                           className={`flex items-center justify-between px-3 py-[6px] mx-3 rounded-md cursor-pointer font-outfit font-medium transition-colors text-[13px] ${
//                             selectedFolderId === f.id
//                               ? "bg-[#8B55DD1F] !text-[#8B55DD]"
//                               : "text-[#1A1A1ACC] hover:bg-gray-100"
//                           }`}
//                           title={`${f.name} (${docCount})`}
//                         >
//                           <span className="min-w-0 flex-1 truncate font-normal  text-[14px]">
//                             {f.name}
//                           </span>
//                           <span
//                             className={`flex-shrink-0 font-medium text-[12px] ml-2 ${
//                               selectedFolderId === f.id
//                                 ? "opacity-70"
//                                 : "text-[#A1A1AA]"
//                             }`}
//                           >
//                             ({docCount})
//                           </span>
//                           {selectedFolderId === f.id && <SelectedFolderIcon />}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>

//               <div className="flex flex-col">
//                 <div className="flex items-center justify-between px-6 mb-2 group flex-shrink-0">
//                   <span
//                     className="text-[#808080] font-outfit text-[13px] font-medium uppercase tracking-wider cursor-pointer"
//                     onClick={() => setIsManualOpen(!isManualOpen)}
//                   >
//                     Manually Added
//                   </span>
//                   <button
//                     onClick={openCreateFolderModal}
//                     className="flex items-center justify-center w-[18px] h-[18px] bg-[#E5E7EB] hover:bg-[#D1D5DB] text-[#808080] transition-colors rounded"
//                     title="Create Folder"
//                   >
//                     <svg
//                       className="w-3.5 h-3.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2.5}
//                         d="M12 4v16m8-8H4"
//                       />
//                     </svg>
//                   </button>
//                 </div>

//                 {isManualOpen && (
//                   <div className="flex flex-col gap-1">
//                     {manualFolders.map((f) => {
//                       const docCount =
//                         f.documents?.length || f.document_count || 0;
//                       return (
//                         <div
//                           key={f.id}
//                           onClick={() => setSelectedFolderId(f.id)}
//                           className={`flex items-center justify-between px-3 py-[6px] mx-3 rounded-md cursor-pointer font-outfit font-medium transition-colors text-[13px] ${
//                             selectedFolderId === f.id
//                               ? "bg-[#8B55DD1F] !text-[#8B55DD]"
//                               : "text-[#1A1A1ACC] hover:bg-gray-100"
//                           }`}
//                           title={`${f.name} (${docCount})`}
//                         >
//                           <span className="min-w-0 flex-1 truncate font-normal  text-[14px]">
//                             {f.name}
//                           </span>
//                           <span
//                             className={`flex-shrink-0 font-medium text-[12px] ml-2 ${
//                               selectedFolderId === f.id
//                                 ? "opacity-70"
//                                 : "text-[#A1A1AA]"
//                             }`}
//                           >
//                             ({docCount})
//                           </span>
//                           {selectedFolderId === f.id && <SelectedFolderIcon />}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="flex-1 flex flex-col min-h-0 bg-white p-4 overflow-hidden">
//         {selectedContracts.length > 0 && (
//           <div className="flex items-center justify-between bg-white px-4 py-3 rounded-lg border border-[#A259FF] shadow-sm mb-4 flex-shrink-0">
//             <span className="text-[#A259FF] font-outfit text-[14px] font-medium">
//               {getSelectedFilesCount()} Documents selected
//             </span>
//             <div className="flex items-center gap-3">
//               {hasSelectedFiles() && selectedFolderId === null && (
//                 <button
//                   className="flex items-center gap-1 px-4 py-1.5 bg-[#A259FF] hover:bg-[#8B55DD] text-white rounded text-[13px] font-medium transition-colors"
//                   onClick={handleMoveToFolder}
//                 >
//                   Move to Folder
//                 </button>
//               )}
//               <button
//                 onClick={handleBulkDelete}
//                 className="flex items-center gap-1 px-4 py-1.5 border border-red-500 text-red-500 hover:bg-red-50 rounded text-[13px] font-medium transition-colors"
//               >
//                 Delete
//               </button>
//               <button
//                 onClick={handleCancel}
//                 className="p-1.5 rounded bg-gray-100 hover:bg-gray-200 transition-colors"
//               >
//                 <img src="/cancel_icon.svg" className="w-4 h-4" alt="Cancel" />
//               </button>
//             </div>
//           </div>
//         )}

//         {selectedFolderId === null && (
//           <div className="flex items-center gap-4 mb-2 flex-shrink-0">
//             <div className="flex-1 bg-white border border-[#E5E7EB] rounded-lg p-4 flex items-center justify-between shadow-sm cursor-default">
//               <div className="flex items-center gap-4">
//                 <div className="w-10 h-10 rounded-md bg-[#FF949433] flex items-center justify-center text-red-500 text-lg">
//                   <ConflictsIcon />
//                 </div>
//                 <div className="flex flex-col">
//                   <span className="text-[#0000008C] font-outfit text-[13px] font-medium">
//                     Conflicts
//                   </span>
//                   <span className="text-[#000000B2] font-outfit text-[20px] font-semibold leading-none mt-[2px]">
//                     {conflictsCount}
//                   </span>
//                 </div>
//               </div>
//               <ArrowIcon />
//             </div>
//             <div className="flex-1 bg-white border border-[#E5E7EB] rounded-lg p-4 flex items-center justify-between shadow-sm cursor-default">
//               <div className="flex items-center gap-4">
//                 <div className="w-10 h-10 rounded-md bg-[#FFF6D1] flex items-center justify-center text-yellow-500 text-lg font-bold">
//                   <GapIcon />
//                 </div>
//                 <div className="flex flex-col">
//                   <span className="text-[#0000008C] font-outfit text-[13px] font-medium">
//                     Knowledge Gaps
//                   </span>
//                   <span className="text-[#000000B2] font-outfit text-[20px] font-semibold leading-none mt-[2px]">
//                     0
//                   </span>
//                 </div>
//               </div>
//               <ArrowIcon />
//             </div>
//             <div className="flex-1 bg-white border border-[#E5E7EB] rounded-lg p-4 flex items-center justify-between shadow-sm cursor-default">
//               <div className="flex items-center gap-4">
//                 <div className="w-10 h-10 rounded-md bg-[#00000012] flex items-center justify-center text-gray-500 text-lg">
//                   <StaleAssetIcon />
//                 </div>
//                 <div className="flex flex-col">
//                   <span className="text-[#0000008C] font-outfit text-[13px] font-medium">
//                     Stale Assets
//                   </span>
//                   <span className="text-[#000000B2] font-outfit text-[20px] font-semibold leading-none mt-[2px]">
//                     0
//                   </span>
//                 </div>
//               </div>
//               <ArrowIcon />
//             </div>
//           </div>
//         )}

//         {/* Dynamic Breadcrumb Path when a folder is selected */}
//         {selectedFolderId !== null && selectedFolderName && (
//           <div className="flex items-center gap-2 mb-3 px-1 flex-shrink-0 font-outfit text-[18px]">
//             <span
//               className="text-[#00000040] cursor-pointer font-medium transition-colors"
//               onClick={() => setSelectedFolderId(null)}
//             >
//               Knowledge Base
//             </span>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="6"
//               height="9"
//               viewBox="0 0 6 9"
//               fill="none"
//             >
//               <path
//                 d="M3.36996 4.5L0.221973 1.35202C0.073991 1.20404 0 1.0157 0 0.786996C0 0.558296 0.073991 0.369955 0.221973 0.221973C0.369955 0.073991 0.558296 0 0.786996 0C1.0157 0 1.20404 0.073991 1.35202 0.221973L5.06502 3.93498C5.14574 4.0157 5.20291 4.10314 5.23655 4.19731C5.27018 4.29148 5.287 4.39238 5.287 4.5C5.287 4.60762 5.27018 4.70852 5.23655 4.80269C5.20291 4.89686 5.14574 4.9843 5.06502 5.06502L1.35202 8.77803C1.20404 8.92601 1.0157 9 0.786996 9C0.558296 9 0.369955 8.92601 0.221973 8.77803C0.073991 8.63004 0 8.4417 0 8.213C0 7.9843 0.073991 7.79596 0.221973 7.64798L3.36996 4.5Z"
//                 fill="#7D7D7D"
//               />
//             </svg>
//             <span className="text-[#7D7D7D] font-medium">
//               {selectedFolderName}
//             </span>
//           </div>
//         )}

//         <div
//           className={`bg-white border border-[#E5E7EB] rounded-lg overflow-hidden flex flex-col ${
//             selectedFolderId === null ? "h-[calc(100vh-250px)]" : "flex-1"
//           }`}
//         >
//           <DataTable
//             displayedFiles={displayedFiles}
//             loading={loading}
//             isAllChecked={isAllChecked}
//             handleSelectAll={handleSelectAll}
//             selectedContracts={selectedContracts}
//             handleCheckboxChange={handleCheckboxChange}
//             getFileIcon={getFileIcon}
//             removeFileExtension={removeFileExtension}
//             darkenColor={darkenColor}
//             openTagModalFor={openTagModalFor}
//             formatDate={formatDate}
//             toggleActionMenu={toggleActionMenu}
//             isActionMenuOpen={isActionMenuOpen}
//             actionMenuPosition={actionMenuPosition}
//             actionMenuRefs={actionMenuRefs}
//             setSelectedFilePreview={setSelectedFilePreview}
//             handleRenameClick={handleRenameClick}
//             handleDownload={handleDownload}
//             handleDelete={handleDelete}
//             handleViewAndIngest={handleViewAndIngest}
//             handleSingleMoveToFolder={handleSingleMoveToFolder} // ADDED HERE
//             setIsActionMenuOpen={setIsActionMenuOpen}
//             columnPreferences={columnPreferences}
//             isFolderView={selectedFolderId !== null}
//             isAllFilesView={selectedFolderId === null} // ADDED HERE
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AllSources;

import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import DataTable from "./DataTable";
import { Spinner } from "./FolderPickerModal";
import ConflictsPage from "./ConflictsPage";
import { ConflictsIcon, GapIcon, StaleAssetIcon, RenameIcon, DeleteIcon } from "./Icons";
import api from "../../chat/api";
import ReviewerActionGate from "../../../components/ReviewerActionGate";
import useCurrentOrgRole from "../../../utils/useCurrentOrgRole";
import { UNFILED, STALE_AFTER_MONTHS, systemFolderAccepts, statusKey, sortDocuments } from "./kbHelpers";
import StaleAssetsPage from "./StaleAssetsPage";
import KnowledgeGapsPage from "./KnowledgeGapsPage";

// Nested children of "Previous Proposals". They are VIEWS, not folders: a
// proposal is captured into the one folder and its evidence_tier decides
// which child it appears under (see rfp.services.kb_folders).
const PROPOSAL_CHILDREN = [
  { key: "past_proposal", label: "Submitted" },
  { key: "won", label: "Won" },
  { key: "delivered", label: "Delivered" },
];
// "Submitted" is the catch-all, so a legacy document with no tier still shows somewhere.
const docProposalTier = (d) =>
  ["won", "delivered"].includes(d.evidence_tier) ? d.evidence_tier : "past_proposal";

// Same look as the document row menu (ActionMenu.jsx).
const MENU_BOX =
  "absolute right-0 z-30 p-1.5 bg-white border border-[#E5E7EB] rounded-lg shadow-lg flex flex-col gap-0.5 cursor-default";
const MENU_ITEM = "w-full flex items-center gap-3 py-2 px-3 rounded-md font-outfit text-[14px] font-medium";
const MENU_ITEM_ACTIVE = `${MENU_ITEM} cursor-pointer transition-all duration-200 hover:bg-gray-100 text-[#71717A]`;
const MENU_ITEM_DELETE = `${MENU_ITEM} cursor-pointer transition-all duration-200 hover:bg-red-100 text-red-500 hover:text-red-600`;
const MENU_ITEM_DISABLED = `${MENU_ITEM} text-[#A1A1AA] cursor-not-allowed`;

const SELECTED_BG = "bg-[#8B55DD1F]";
const SELECTED_TEXT = "text-[#6F35C4]";

const FolderGlyph = ({ system }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill={system ? "#F7E9F5" : "none"}
    stroke={system ? "#A04A97" : "#52525B"}
    strokeWidth="1.7"
    strokeLinejoin="round"
    className="flex-shrink-0"
  >
    <path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  </svg>
);

const Chevron = ({ open }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#A04A97"
    strokeWidth="3.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`flex-shrink-0 transition-transform duration-150 ${open ? "rotate-90" : ""}`}
  >
    <path d="M9 6l6 6-6 6" />
  </svg>
);

const LockGlyph = ({ color = "#A04A97", size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

const DotsGlyph = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#52525B">
    <circle cx="5" cy="12" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="19" cy="12" r="2" />
  </svg>
);

const BreadcrumbArrow = () => (
  <svg width="6" height="9" viewBox="0 0 6 9" fill="#52525B">
    <path d="M3.37 4.5.22 1.35a.79.79 0 0 1 1.13-1.13l3.71 3.71a.8.8 0 0 1 0 1.13L1.35 8.78A.79.79 0 0 1 .22 7.65L3.37 4.5z" />
  </svg>
);

const NameInput = ({ initial = "", placeholder, onCommit, onCancel }) => {
  const [value, setValue] = useState(initial);
  const done = useRef(false);
  const commit = async () => {
    if (done.current) return;
    done.current = true;
    const ok = await onCommit(value);
    if (ok === false) done.current = false;
  };
  return (
    <input
      autoFocus
      value={value}
      placeholder={placeholder}
      onChange={(e) => setValue(e.target.value)}
      onFocus={(e) => e.target.select()}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        // An empty name never creates "Untitled folder"; Enter waits for a name, clicking away cancels.
        if (e.key === "Enter" && value.trim()) commit();
        if (e.key === "Escape") {
          done.current = true;
          onCancel();
        }
      }}
      onBlur={commit}
      className="flex-1 min-w-0 h-[26px] px-2 border border-[#A04A97] rounded font-outfit text-[14px] text-[#18181B] outline-none shadow-[0_0_0_2px_#F3D9EF]"
    />
  );
};

const InsightCard = ({ icon, iconBg, label, value, title, onClick }) => (
  <div
    title={title}
    onClick={onClick}
    className={`flex-1 flex items-center gap-3 px-[14px] py-[10px] border border-[#D4D4D8] rounded-lg bg-white ${
      onClick ? "cursor-pointer hover:border-[#A04A97]" : "cursor-default"
    }`}
  >
    <span className={`w-9 h-9 rounded-md flex items-center justify-center ${iconBg}`}>{icon}</span>
    <div className="flex flex-col flex-1">
      <span className="font-outfit text-[13px] font-medium text-[#3F3F46]">{label}</span>
      <span className="font-outfit text-[20px] font-semibold text-[#18181B] leading-[1.1]">{value}</span>
    </div>
    {onClick && (
      <svg width="7" height="12" viewBox="0 0 7 12" fill="none" stroke="#A1A1AA" strokeWidth="1.6" strokeLinecap="round">
        <path d="M1 1l5 5-5 5" />
      </svg>
    )}
  </div>
);

const AllSources = ({
  allDocuments,
  folders,
  selectedFolderId,
  setSelectedFolderId,
  selectedProposalTier,
  setSelectedProposalTier,
  isCreatingFolder,
  onStartCreateFolder,
  onCancelCreateFolder,
  onCreateFolder,
  onRenameFolder,
  draggingDoc,
  setDraggingDoc,
  onDropDocOnFolder,
  onDeleteFolder,
  onReorderFolders,
  onSaveDocumentOrder,
  onUploadClick,
  isFiltered,
  sortKey,
  sortDir,
  onSort,
  selectedContracts,
  getSelectedFilesCount,
  hasSelectedFiles,
  handleMoveToFolder,
  handleSingleMoveToFolder,
  handleBulkDelete,
  handleCancel,
  displayedFiles,
  loading,
  isAllChecked,
  handleSelectAll,
  handleCheckboxChange,
  getFileIcon,
  removeFileExtension,
  darkenColor,
  openTagModalFor,
  applyingTagDocIds = [],
  formatDate,
  toggleActionMenu,
  isActionMenuOpen,
  setIsActionMenuOpen,
  actionMenuPosition,
  actionMenuRefs,
  setSelectedFilePreview,
  handleRenameClick,
  handleDownload,
  handleDelete,
  handleViewAndIngest,
  handleSetProposalTier,
  columnPreferences,
  isReviewer,
  onRemoveFromFolder,
  pendingDocIds = [],
  pendingFolderIds = [],
  draftFolderName = "",
  creatingFolderName = null,
  onDocumentReplaced,
  onDocumentsChanged,
  onSourceUploaded,
  onFolderCheckMove,
  onFolderCheckKeep,
}) => {
  const [isSuggestedOpen, setIsSuggestedOpen] = useState(true);
  const [isManualOpen, setIsManualOpen] = useState(true);
  const [conflictsCount, setConflictsCount] = useState(0);
  const [conflictsCheck, setConflictsCheck] = useState(0);
  // "conflicts" or "stale" while that page replaces the document table.
  const [insightPage, setInsightPage] = useState(null);
  const [staleCount, setStaleCount] = useState(null);
  const [gapsCount, setGapsCount] = useState(null);
  const [menuFolderId, setMenuFolderId] = useState(null);
  const [menuUp, setMenuUp] = useState(false);
  const [renamingFolderId, setRenamingFolderId] = useState(null);
  const [dropFolderId, setDropFolderId] = useState(null);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [isDeletingFolder, setIsDeletingFolder] = useState(false);
  const [deleteFolderFiles, setDeleteFolderFiles] = useState(false);
  // While a folder is dragged: its group and the live order shown in the panel.
  const [folderDrag, setFolderDrag] = useState(null);
  const folderDragRef = useRef(null);
  const role = useCurrentOrgRole();

  const selectFolder = (folderId, tier = null) => {
    setSelectedFolderId(folderId);
    if (setSelectedProposalTier) setSelectedProposalTier(tier);
    setMenuFolderId(null);
    setInsightPage(null);
  };

  // Count requests can be slow and overlap; only the latest answer may set a card.
  const latestConflictsRequest = useRef(0);
  const latestStaleRequest = useRef(0);

  useEffect(() => {
    // Open conflicts across the whole workspace, each pair counted once.
    const fetchConflicts = async () => {
      const request = ++latestConflictsRequest.current;
      try {
        const orgId = Cookies.get("selected_org_id");
        const query = orgId ? `?organization_id=${encodeURIComponent(orgId)}` : "";
        const response = await api.get(`/api/v1/rfp/knowledge-base/conflicts/workspace/${query}`);
        if (request === latestConflictsRequest.current) setConflictsCount(response.data?.count ?? 0);
      } catch (error) {
        console.error("Failed to fetch conflicts:", error);
      }
    };
    fetchConflicts();
  }, [allDocuments.length, conflictsCheck]);

  // The conflict check runs in the background after a document is ingested, so ask again a few times.
  const ingestedCount = allDocuments.filter((d) => statusKey(d.status) === "ingested").length;
  const lastIngestedCount = useRef(null);
  useEffect(() => {
    const before = lastIngestedCount.current;
    lastIngestedCount.current = ingestedCount;
    if (before === null || ingestedCount <= before) return;
    const timers = [8000, 20000, 60000, 120000].map((ms) => setTimeout(() => setConflictsCheck((n) => n + 1), ms));
    return () => timers.forEach(clearTimeout);
  }, [ingestedCount]);

  // Reviewers can't see workspace gaps; while the role is still loading the backend decides.
  const canSeeGaps = !(Cookies.get("selected_org_id") && role === "Reviewer");
  // Re-counted as documents change, since an ingested document can close a gap.
  useEffect(() => {
    if (!canSeeGaps) return;
    const orgId = Cookies.get("selected_org_id");
    api
      .get(`/api/v1/rfp/knowledge-base/gaps/${orgId ? `?organization_id=${encodeURIComponent(orgId)}` : ""}`)
      .then((res) => setGapsCount(res.data?.open_count ?? 0))
      .catch(() => setGapsCount(null));
  }, [canSeeGaps, ingestedCount, allDocuments.length]);

  useEffect(() => {
    if (isCreatingFolder) setIsManualOpen(true);
  }, [isCreatingFolder]);

  // Escape closes the folder delete window, but not while a delete is running.
  useEffect(() => {
    if (!folderToDelete || isDeletingFolder) return undefined;
    const onKey = (e) => e.key === "Escape" && setFolderToDelete(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [folderToDelete, isDeletingFolder]);

  useEffect(() => {
    if (menuFolderId === null) return;
    const close = () => setMenuFolderId(null);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, [menuFolderId]);

  // Stale count comes from the server so "still valid" and new versions are taken into account.
  useEffect(() => {
    const request = ++latestStaleRequest.current;
    const orgId = Cookies.get("selected_org_id");
    const params = new URLSearchParams({ months: String(STALE_AFTER_MONTHS) });
    if (orgId) params.append("organization_id", orgId);
    api
      .get(`/api/v1/rfp/knowledge-base/stale/?${params.toString()}`)
      .then((res) => request === latestStaleRequest.current && setStaleCount(res.data?.count ?? 0))
      .catch(() => request === latestStaleRequest.current && setStaleCount(null));
  }, [allDocuments.length]);

  const unfiledCount = allDocuments.filter((d) => d.folderIds.length === 0).length;
  const folderCount = (f) => allDocuments.filter((d) => d.folderIds.includes(f.id)).length;
  const tierCount = (f, tier) =>
    allDocuments.filter((d) => d.folderIds.includes(f.id) && docProposalTier(d) === tier).length;

  const groupFolders = (isDefault) => {
    const list = folders.filter((f) => !!f.is_default === isDefault);
    if (!folderDrag || folderDrag.isDefault !== isDefault) return list;
    return folderDrag.order.map((id) => list.find((f) => f.id === id)).filter(Boolean);
  };
  const suggestedFolders = groupFolders(true);
  const manualFolders = groupFolders(false);
  const selectedFolder = folders.find((f) => f.id === selectedFolderId) || null;
  const isAllView = selectedFolderId === null;
  const isUnfiledView = selectedFolderId === UNFILED;
  const isFolderView = !!selectedFolder;
  const canDragRows = !isReviewer;
  // Previous Proposals groups rows by tier, so a hand-made order can't hold there.
  const canCustomOrder =
    isFolderView && !selectedProposalTier && selectedFolder?.name !== "Previous Proposals";
  const customOrderOn = canCustomOrder && (selectedFolder?.document_order || []).length > 0;
  // Dropping a row on another row reorders; no switch needed.
  const canReorder = canCustomOrder && !isReviewer;

  // Every document in the folder, not just the ones a search or filter shows.
  const fullFolderOrder = (visibleFirst) => {
    const inFolder = sortDocuments(
      allDocuments.filter((d) => d.id && d.folderIds.includes(selectedFolder.id)),
      "added",
      "desc"
    ).map((d) => d.id);
    const head = visibleFirst
      ? displayedFiles.map((d) => d.id).filter(Boolean)
      : (selectedFolder.document_order || []).filter((id) => inFolder.includes(id));
    return [...head, ...inFolder.filter((id) => !head.includes(id))];
  };

  const viewTitle = isAllView ? "All Files" : isUnfiledView ? "Not in any folder" : selectedFolder?.name || "";
  const tierLabel = PROPOSAL_CHILDREN.find((c) => c.key === selectedProposalTier)?.label;
  const accepts = selectedFolder?.is_default ? systemFolderAccepts(selectedFolder.name) : "";

  const folderById = folders.reduce((map, f) => {
    map[f.id] = f;
    return map;
  }, {});

  const emptyState = isFiltered
    ? { title: "No documents match your search", body: "Try a different search or clear the filters." }
    : isFolderView && tierLabel
    ? {
        title: `No ${tierLabel.toLowerCase()} proposals yet`,
        body: `Proposals marked ${tierLabel} show up here. Anything you upload here is filed as ${tierLabel}.`,
        actionLabel: isReviewer ? null : `Upload to ${tierLabel}`,
        onAction: onUploadClick,
      }
    : isFolderView
    ? {
        title: "This folder is empty",
        body: "Drag documents from All Files onto this folder in the left panel, or upload new ones straight into it.",
        actionLabel: isReviewer ? null : `Upload to ${selectedFolder.name}`,
        onAction: onUploadClick,
      }
    : isUnfiledView
    ? { title: "Every document is in a folder", body: "Documents uploaded without a folder show up here." }
    : {
        title: "No documents yet",
        body: "Upload your documents to build your knowledge base. They'll show up here once added.",
      };

  const groupIds = (isDefault) =>
    folders.filter((x) => !!x.is_default === isDefault).map((x) => x.id);

  const finishFolderDrag = () => {
    const drag = folderDragRef.current;
    folderDragRef.current = null;
    setFolderDrag(null);
    if (!drag) return;
    if (groupIds(drag.isDefault).join(",") !== drag.order.join(",")) onReorderFolders(drag.order);
  };

  const updateFolderDrag = (next) => {
    folderDragRef.current = next;
    setFolderDrag(next);
  };

  const folderDragProps = (f) =>
    isReviewer || renamingFolderId === f.id
      ? {}
      : {
          draggable: true,
          onDragStart: (e) => {
            e.dataTransfer.effectAllowed = "move";
            e.dataTransfer.setData("text/plain", f.name);
            setMenuFolderId(null);
            const isDefault = !!f.is_default;
            updateFolderDrag({ id: f.id, isDefault, order: groupIds(isDefault) });
          },
          onDragEnd: finishFolderDrag,
        };

  const dropHandlers = (f) => {
    if (draggingDoc) {
      return {
        onDragOver: (e) => {
          e.preventDefault();
          e.dataTransfer.dropEffect = "move";
          if (dropFolderId !== f.id) setDropFolderId(f.id);
        },
        onDragLeave: () => setDropFolderId((cur) => (cur === f.id ? null : cur)),
        onDrop: (e) => {
          e.preventDefault();
          setDropFolderId(null);
          onDropDocOnFolder(draggingDoc, f);
        },
      };
    }
    if (folderDrag) {
      return {
        onDragOver: (e) => {
          if (folderDrag.isDefault !== !!f.is_default) return;
          e.preventDefault();
          if (f.id === folderDrag.id) return;
          const order = [...folderDrag.order];
          const from = order.indexOf(folderDrag.id);
          const to = order.indexOf(f.id);
          if (from === -1 || to === -1) return;
          order.splice(from, 1);
          order.splice(to, 0, folderDrag.id);
          updateFolderDrag({ ...folderDrag, order });
        },
        onDrop: (e) => {
          e.preventDefault();
          finishFolderDrag();
        },
      };
    }
    return {};
  };

  const folderRowClass = (active, f) =>
    `relative flex items-center gap-2 py-[6px] pl-2 pr-1 rounded-md cursor-pointer font-outfit transition-colors ${
      active ? `${SELECTED_BG} ${SELECTED_TEXT}` : "text-[#27272A] hover:bg-[#F1EAF4]"
    } ${dropFolderId === f.id || pendingFolderIds.includes(f.id) ? "shadow-[inset_0_0_0_2px_#A04A97]" : ""} ${
      folderDrag?.id === f.id ? "opacity-45" : ""
    }`;

  // While an add/move/remove is working on this folder, a spinner takes the count's place.
  const folderCountCell = (f, active) =>
    pendingFolderIds.includes(f.id) ? (
      <Spinner color="#A04A97" size={12} />
    ) : (
      <span className={`text-[12px] font-semibold ${active ? SELECTED_TEXT : "text-[#3F3F46]"}`}>
        {folderCount(f)}
      </span>
    );

  const renderMenuButton = (f) => (
    <button
      type="button"
      aria-label={`${f.name} options`}
      onClick={(e) => {
        e.stopPropagation();
        const panel = e.currentTarget.closest(".overflow-y-auto")?.getBoundingClientRect();
        const row = e.currentTarget.getBoundingClientRect();
        const needed = f.is_default ? 190 : 110;
        setMenuUp(!!panel && panel.bottom - row.bottom < needed && row.top - panel.top > needed);
        setMenuFolderId((cur) => (cur === f.id ? null : f.id));
      }}
      className="w-[22px] h-[22px] flex-shrink-0 flex items-center justify-center rounded hover:bg-[#E9DDF0]"
    >
      <DotsGlyph />
    </button>
  );

  const sectionHeader = (label, open, onToggle, trailing) => (
    <div
      onClick={onToggle}
      className="flex items-center gap-2 mx-3 py-[6px] pl-3 pr-2 rounded-md cursor-pointer select-none hover:bg-[#F1EAF4]"
    >
      <Chevron open={open} />
      <span className="flex-1 font-outfit text-[12px] font-semibold tracking-[0.8px] uppercase text-[#A04A97] whitespace-nowrap">
        {label}
      </span>
      {trailing}
    </div>
  );

  return (
    <div className="kb-scope flex flex-1 min-h-0 w-full bg-white">
      {/* Keyboard focus shows in the app's purple; a mouse click leaves no outline. */}
      <style>{`
        .kb-scope :focus:not(:focus-visible) { outline: none; box-shadow: none; }
        .kb-scope button:focus-visible, .kb-scope input:focus-visible, .kb-scope [tabindex]:focus-visible {
          outline: 2px solid #A04A97; outline-offset: 2px;
        }
      `}</style>
      {/* Left panel */}
      <div className="w-[280px] min-h-0 flex-shrink-0 bg-[#FAFAFA] border-r border-[#D4D4D8] flex flex-col pt-[14px]">
        <div className="px-3 flex flex-col gap-[2px] flex-shrink-0">
          {[
            { id: null, label: "All Files", count: allDocuments.length, dashed: false },
            { id: UNFILED, label: "Not in any folder", count: unfiledCount, dashed: true },
          ].map((row) => {
            const active = selectedFolderId === row.id;
            return (
              <div
                key={row.label}
                onClick={() => selectFolder(row.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-md cursor-pointer font-outfit transition-colors ${
                  active ? `${SELECTED_BG} ${SELECTED_TEXT}` : "text-[#18181B] hover:bg-[#F1EAF4]"
                }`}
              >
                {row.dashed ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeDasharray="3 2.5">
                    <rect x="4" y="3" width="16" height="18" rx="2" />
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                )}
                <span className="flex-1 text-[14px] font-medium">{row.label}</span>
                <span className="text-[12px] font-semibold">{loading ? "" : row.count}</span>
              </div>
            );
          })}
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar pt-3 pb-4 flex flex-col gap-3">
          <div className="mx-6 border-t border-[#E4E4E7]" />
          {loading ? (
            <div className="flex flex-col gap-2 px-6">
              {Array.from({ length: 9 }).map((_, i) => (
                <div
                  key={i}
                  className="h-3.5 rounded bg-[#E5E7EB] animate-pulse"
                  style={{ width: `${[80, 60, 70, 55, 75][i % 5]}%` }}
                />
              ))}
            </div>
          ) : (
            <>
              <div>
                {sectionHeader(
                  "Suggested folders",
                  isSuggestedOpen,
                  () => setIsSuggestedOpen((v) => !v),
                  <span title="System folders only accept matching document types" className="flex">
                    <LockGlyph />
                  </span>
                )}
                {isSuggestedOpen && (
                  <div className="relative mt-1 ml-[29px] mr-3 pl-[6px] flex flex-col gap-[1px]">
                    <span className="absolute left-0 top-[2px] bottom-[2px] w-[1.5px] bg-[#E4E4E7]" />
                    {suggestedFolders.map((f) => {
                      const active = selectedFolderId === f.id && !selectedProposalTier;
                      const isProposals = f.name === "Previous Proposals";
                      return (
                        <div key={f.id}>
                          <div
                            onClick={() => selectFolder(f.id)}
                            title={f.name}
                            className={folderRowClass(active, f)}
                            {...folderDragProps(f)}
                            {...dropHandlers(f)}
                          >
                            <FolderGlyph system />
                            <span className="flex-1 min-w-0 truncate text-[14px]">{f.name}</span>
                            {folderCountCell(f, active)}
                            {renderMenuButton(f)}
                            {menuFolderId === f.id && (
                              <div
                                onClick={(e) => e.stopPropagation()}
                                className={`${MENU_BOX} w-56 ${menuUp ? "bottom-[34px]" : "top-[34px]"}`}
                              >
                                <div className={MENU_ITEM_DISABLED}>
                                  <span className="flex items-center justify-center opacity-50">
                                    <RenameIcon />
                                  </span>
                                  Rename
                                </div>
                                <div className={MENU_ITEM_DISABLED}>
                                  <span className="w-4 h-4 flex items-center justify-center">
                                    <DeleteIcon />
                                  </span>
                                  Delete
                                </div>
                                <p className="mx-3 mt-1 mb-1.5 pt-2 border-t border-[#E5E7EB] font-outfit text-[12px] leading-[1.45] text-[#71717A]">
                                  System folders keep fixed names because Sensa uses them to tag evidence. Accepts: {systemFolderAccepts(f.name) || "matching documents"}.
                                </p>
                              </div>
                            )}
                          </div>
                          {isProposals && (
                            <div className="flex flex-col mt-[2px] ml-8">
                              {PROPOSAL_CHILDREN.map((child) => {
                                const childActive = selectedFolderId === f.id && selectedProposalTier === child.key;
                                return (
                                  <div
                                    key={child.key}
                                    onClick={() => selectFolder(f.id, child.key)}
                                    className={`flex items-center gap-2 px-2 py-[5px] rounded-md cursor-pointer font-outfit text-[13px] transition-colors ${
                                      childActive ? `${SELECTED_BG} ${SELECTED_TEXT}` : "text-[#27272A] hover:bg-[#F1EAF4]"
                                    }`}
                                  >
                                    <span className="w-[5px] h-[5px] rounded-full bg-[#A1A1AA]" />
                                    <span className="flex-1">{child.label}</span>
                                    <span className="text-[12px] font-semibold">{tierCount(f, child.key)}</span>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div>
                {sectionHeader(
                  "Your folders",
                  isManualOpen,
                  () => setIsManualOpen((v) => !v),
                  <ReviewerActionGate active={isReviewer} place="left">
                    <button
                      type="button"
                      title="Create folder"
                      onClick={(e) => {
                        e.stopPropagation();
                        onStartCreateFolder();
                      }}
                      className="w-[22px] h-[22px] flex items-center justify-center border border-[#C9A9D6] rounded bg-white hover:border-[#A04A97]"
                    >
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#A04A97" strokeWidth="2.8" strokeLinecap="round">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                    </button>
                  </ReviewerActionGate>
                )}
                {isManualOpen && (
                  <div className="relative mt-1 ml-[29px] mr-3 pl-[6px] flex flex-col gap-[1px]">
                    <span className="absolute left-0 top-[2px] bottom-[2px] w-[1.5px] bg-[#E4E4E7]" />
                    {manualFolders.map((f) => {
                      const active = selectedFolderId === f.id;
                      const renaming = renamingFolderId === f.id;
                      return (
                        <div
                          key={f.id}
                          onClick={() => !renaming && selectFolder(f.id)}
                          title={f.name}
                          className={folderRowClass(active, f)}
                          {...folderDragProps(f)}
                          {...dropHandlers(f)}
                        >
                          <FolderGlyph />
                          {renaming ? (
                            <NameInput
                              initial={f.name}
                              onCommit={async (name) => {
                                const ok = await onRenameFolder(f, name);
                                if (ok !== false) setRenamingFolderId(null);
                                return ok;
                              }}
                              onCancel={() => setRenamingFolderId(null)}
                            />
                          ) : (
                            <span className="flex-1 min-w-0 truncate text-[14px]">{f.name}</span>
                          )}
                          {folderCountCell(f, active)}
                          {!isReviewer && renderMenuButton(f)}
                          {menuFolderId === f.id && (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              className={`${MENU_BOX} w-48 ${menuUp ? "bottom-[34px]" : "top-[34px]"}`}
                            >
                              <button
                                type="button"
                                onClick={() => {
                                  setMenuFolderId(null);
                                  setRenamingFolderId(f.id);
                                }}
                                className={MENU_ITEM_ACTIVE}
                              >
                                <span className="flex items-center justify-center">
                                  <RenameIcon />
                                </span>
                                Rename
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setMenuFolderId(null);
                                  setDeleteFolderFiles(false);
                                  setFolderToDelete(f);
                                }}
                                className={MENU_ITEM_DELETE}
                              >
                                <span className="w-4 h-4 flex items-center justify-center">
                                  <DeleteIcon />
                                </span>
                                Delete folder
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {creatingFolderName && (
                      <div className="flex items-center gap-2 py-[6px] pl-2 pr-1 rounded-md bg-[#F4F0F8] text-[#71717A] font-outfit">
                        <FolderGlyph />
                        <span className="flex-1 min-w-0 truncate text-[14px]">{creatingFolderName}</span>
                        <span className="flex items-center gap-1.5 text-[12px] whitespace-nowrap">
                          <Spinner color="#A04A97" size={12} />
                          Creating...
                        </span>
                      </div>
                    )}
                    {isCreatingFolder && (
                      <div className="flex items-center gap-2 py-[6px] pl-2 pr-1 rounded-md bg-[#8B55DD1F]">
                        <FolderGlyph />
                        <NameInput
                          initial={draftFolderName}
                          placeholder="Folder name"
                          onCommit={onCreateFolder}
                          onCancel={onCancelCreateFolder}
                        />
                      </div>
                    )}
                    {!manualFolders.length && !isCreatingFolder && !creatingFolderName && (
                      <span className="pl-2 py-[6px] font-outfit text-[13px] text-[#71717A]">No folders yet</span>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Main area */}
      {insightPage === "stale" ? (
        <div className="flex-1 min-w-0 flex flex-col min-h-0 bg-white px-6 pt-4 pb-2 overflow-hidden">
          <StaleAssetsPage
            isReviewer={isReviewer}
            onBack={() => setInsightPage(null)}
            onCountChange={setStaleCount}
            formatDate={formatDate}
            refreshKey={allDocuments.length}
            onDelete={(item) => handleDelete({ ...item, isFolder: false })}
            onReplaced={onDocumentReplaced}
            onOpenDocument={(item) =>
              setSelectedFilePreview({ pdf_url: item.file_url, file_type: item.file_type, name: item.name })
            }
          />
        </div>
      ) : insightPage === "gaps" && canSeeGaps ? (
        <div className="flex-1 min-w-0 flex flex-col min-h-0 bg-white px-6 pt-4 pb-2 overflow-hidden">
          <KnowledgeGapsPage
            onBack={() => setInsightPage(null)}
            onCountChange={setGapsCount}
            formatDate={formatDate}
            refreshKey={ingestedCount}
            onSourceUploaded={onSourceUploaded}
            onOpenDocument={(doc) => {
              const full = allDocuments.find((d) => d.id === doc.id);
              if (full) setSelectedFilePreview({ pdf_url: full.file_url || full.pdf_url, file_type: full.file_type, name: full.name });
            }}
          />
        </div>
      ) : insightPage === "conflicts" ? (
        <div className="flex-1 min-w-0 flex flex-col min-h-0 bg-white px-6 pt-4 pb-2 overflow-hidden">
          <ConflictsPage
            isReviewer={isReviewer}
            onBack={() => setInsightPage(null)}
            onCountChange={setConflictsCount}
            formatDate={formatDate}
            refreshKey={allDocuments.length}
            onDeleted={() => {
              onDocumentsChanged?.();
              setConflictsCheck((n) => n + 1);
            }}
            onOpenDocument={(side) =>
              setSelectedFilePreview({
                pdf_url: side.file_url,
                file_type: side.file_type,
                name: side.name,
                page: side.page,
              })
            }
          />
        </div>
      ) : (
      <div className="flex-1 min-w-0 flex flex-col min-h-0 bg-white p-4 gap-3 overflow-hidden">
        {selectedContracts.length > 0 && (
          <div className="flex items-center justify-between bg-white px-4 py-3 rounded-lg border border-[#A259FF] shadow-sm flex-shrink-0">
            <span className="text-[#A259FF] font-outfit text-[14px] font-medium">
              {getSelectedFilesCount()} {getSelectedFilesCount() === 1 ? "document" : "documents"} selected
            </span>
            {/* While a folder action is working, the buttons wait so nothing is sent twice. */}
            <div className={`flex items-center gap-3 ${pendingDocIds.length ? "opacity-60 pointer-events-none" : ""}`}>
              {hasSelectedFiles() && (
                <ReviewerActionGate active={isReviewer} place="bottom">
                  <button
                    className="flex items-center gap-1 px-4 py-1.5 bg-[#A259FF] hover:bg-[#8B55DD] text-white rounded text-[13px] font-medium transition-colors"
                    onClick={handleMoveToFolder}
                  >
                    Move to Folder
                  </button>
                </ReviewerActionGate>
              )}
              {hasSelectedFiles() && isFolderView && (
                <ReviewerActionGate active={isReviewer} place="bottom">
                  <button
                    className="flex items-center gap-1 px-4 py-1.5 border border-[#A259FF] text-[#A259FF] hover:bg-[#F8F3FF] rounded text-[13px] font-medium transition-colors"
                    onClick={() =>
                      onRemoveFromFolder(displayedFiles.filter((d) => selectedContracts.includes(d.id)))
                    }
                  >
                    Remove from Folder
                  </button>
                </ReviewerActionGate>
              )}
              <ReviewerActionGate active={isReviewer} place="bottom">
                <button
                  onClick={handleBulkDelete}
                  className="flex items-center gap-1 px-4 py-1.5 border border-red-500 text-red-500 hover:bg-red-50 rounded text-[13px] font-medium transition-colors"
                >
                  Delete
                </button>
              </ReviewerActionGate>
              <button onClick={handleCancel} className="p-1.5 rounded bg-gray-100 hover:bg-gray-200 transition-colors">
                <img src="/cancel_icon.svg" className="w-4 h-4" alt="Cancel" />
              </button>
            </div>
          </div>
        )}

        {isAllView && (
          <div className="flex gap-3 flex-shrink-0">
            <InsightCard
              icon={<span className="text-red-500"><ConflictsIcon /></span>}
              iconBg="bg-[#FF949433]"
              label="Conflicts"
              value={conflictsCount}
              title="Documents that state different facts"
              onClick={() => setInsightPage("conflicts")}
            />
            <InsightCard
              icon={<span className="text-yellow-500"><GapIcon /></span>}
              iconBg="bg-[#FFF6D1]"
              label="Knowledge Gaps"
              value={canSeeGaps ? gapsCount ?? "–" : <span className="text-[13px] font-medium text-[#71717A]">Admins and editors only</span>}
              title="Chat questions Sensa couldn't answer from the Knowledge Base"
              onClick={canSeeGaps && gapsCount != null ? () => setInsightPage("gaps") : undefined}
            />
            <InsightCard
              icon={<span className="text-gray-500"><StaleAssetIcon /></span>}
              iconBg="bg-[#00000012]"
              label="Stale Assets"
              value={staleCount ?? "–"}
              title={`Ingested documents not updated for more than ${STALE_AFTER_MONTHS} months`}
              onClick={() => setInsightPage("stale")}
            />
          </div>
        )}

        <div className="flex items-center gap-2 min-h-[32px] min-w-0 flex-shrink-0 font-outfit">
          {isFolderView && (
            <>
              <span
                onClick={() => selectFolder(null)}
                className="text-[17px] font-medium text-[#52525B] cursor-pointer hover:text-[#A04A97] whitespace-nowrap"
              >
                Knowledge Base
              </span>
              <BreadcrumbArrow />
            </>
          )}
          <span
            onClick={tierLabel ? () => selectFolder(selectedFolderId) : undefined}
            className={`text-[17px] whitespace-nowrap ${
              tierLabel ? "font-medium text-[#52525B] cursor-pointer hover:text-[#A04A97]" : "font-semibold text-[#18181B]"
            }`}
          >
            {viewTitle}
          </span>
          {tierLabel && (
            <>
              <BreadcrumbArrow />
              <span className="text-[17px] font-semibold text-[#18181B] whitespace-nowrap">{tierLabel}</span>
            </>
          )}
          {!loading && (
            <span className="text-[13px] font-medium text-[#3F3F46] whitespace-nowrap">
               {displayedFiles.length} {displayedFiles.length === 1 ? "document" : "documents"}
            </span>
          )}
          {accepts && (
            <span
              title={`Accepts only: ${accepts}`}
              className="ml-[6px] inline-flex items-center gap-[6px] px-[10px] py-[3px] rounded-full bg-[#F4F0F8] border border-[#C9A9D6] text-[12px] font-medium text-[#5B2456] whitespace-nowrap overflow-hidden text-ellipsis max-w-[440px]"
            >
              <LockGlyph color="#5B2456" size={11} />
              Accepts only: {accepts}
            </span>
          )}
          {canReorder && customOrderOn && (
            <span className="ml-auto inline-flex items-center gap-2 text-[13px] font-medium text-[#A04A97] whitespace-nowrap">
              Custom order
              <span className="text-[#A1A1AA]">·</span>
              <button
                type="button"
                onClick={() => onSaveDocumentOrder(selectedFolder.id, [])}
                title="Go back to sorting by column"
                className="text-[#52525B] underline underline-offset-2 hover:text-[#A04A97]"
              >
                Reset
              </button>
            </span>
          )}
          {canReorder && !customOrderOn && displayedFiles.length > 1 && (
            <span className="ml-auto text-[12px] text-[#71717A] whitespace-nowrap">Drag rows to reorder</span>
          )}
        </div>

        <div className="flex-1 min-h-0 bg-white border border-[#D4D4D8] rounded-lg overflow-hidden flex flex-col">
          <DataTable
            displayedFiles={displayedFiles}
            loading={loading}
            isAllChecked={isAllChecked}
            handleSelectAll={handleSelectAll}
            selectedContracts={selectedContracts}
            handleCheckboxChange={handleCheckboxChange}
            getFileIcon={getFileIcon}
            removeFileExtension={removeFileExtension}
            darkenColor={darkenColor}
            openTagModalFor={openTagModalFor}
            applyingTagDocIds={applyingTagDocIds}
            formatDate={formatDate}
            toggleActionMenu={toggleActionMenu}
            isActionMenuOpen={isActionMenuOpen}
            actionMenuPosition={actionMenuPosition}
            actionMenuRefs={actionMenuRefs}
            setSelectedFilePreview={setSelectedFilePreview}
            handleRenameClick={handleRenameClick}
            handleDownload={handleDownload}
            handleDelete={handleDelete}
            handleViewAndIngest={handleViewAndIngest}
            handleSingleMoveToFolder={handleSingleMoveToFolder}
            handleRemoveFromFolder={isFolderView ? onRemoveFromFolder : undefined}
            onFolderCheckMove={onFolderCheckMove}
            onFolderCheckKeep={onFolderCheckKeep}
            pendingDocIds={pendingDocIds}
            setIsActionMenuOpen={setIsActionMenuOpen}
            columnPreferences={columnPreferences}
            isFolderView={isFolderView}
            isAllFilesView={!isFolderView}
            isReviewer={isReviewer}
            selectedFolderName={selectedFolder?.name || null}
            selectedProposalTier={selectedProposalTier}
            handleSetProposalTier={handleSetProposalTier}
            showFolderColumn={isAllView}
            folderById={folderById}
            onOpenFolder={(id) => selectFolder(id)}
            sortKey={sortKey}
            sortDir={sortDir}
            onSort={(col) => {
              // Sorting by a column replaces the folder's custom order.
              if (customOrderOn) onSaveDocumentOrder(selectedFolder.id, []);
              onSort(col);
            }}
            canDragRows={canDragRows}
            onRowDragStart={setDraggingDoc}
            onRowDragEnd={() => {
              setDraggingDoc(null);
              setDropFolderId(null);
            }}
            emptyState={emptyState}
            customOrder={customOrderOn}
            canReorder={canReorder}
            onRowReorder={(dragId, overId) => {
              // The first drag starts from what's on screen; later drags start from the saved order.
              const ids = fullFolderOrder(!customOrderOn);
              const from = ids.indexOf(dragId);
              const to = ids.indexOf(overId);
              if (from === -1 || to === -1 || from === to) return;
              ids.splice(from, 1);
              ids.splice(to, 0, dragId);
              onSaveDocumentOrder(selectedFolder.id, ids);
            }}
          />
        </div>
      </div>
      )}

      {folderToDelete &&
        (() => {
          const docs = allDocuments.filter((d) => d.folderIds.includes(folderToDelete.id));
          const n = docs.length;
          const plural = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`;
          const inOtherFolders = docs.filter((d) => d.folderIds.length > 1).length;
          const options = [
            [false, "keep", "Keep the files", "They stay in the Knowledge Base under “Not in any folder”."],
            [
              true,
              "delete",
              "Delete the files too",
              `${n === 1 ? "The file is" : n === 2 ? "Both files are" : `All ${n} files are`} removed for good: the files, their search data and their conflicts. This can't be undone.`,
            ],
          ];
          return (
            <div className="fixed inset-0 z-[9999] bg-[rgba(24,16,28,0.45)] flex items-center justify-center">
              <div
                role="dialog"
                aria-modal="true"
                className="w-[480px] max-w-[92vw] max-h-[90vh] bg-white rounded-xl p-6 shadow-[0_24px_48px_rgba(24,16,28,0.3)] flex flex-col gap-3 font-outfit"
              >
                <p className="m-0 text-[18px] font-semibold text-[#18181B] break-words">
                  Delete “{folderToDelete.name}”?
                </p>
                <p className="m-0 text-[14px] leading-[1.55] text-[#27272A]">
                  {n ? `This folder has ${plural(n, "file")}.` : "This folder is empty. Nothing else is affected."}
                </p>
                {n > 0 && (
                  <div className="flex flex-col gap-2">
                    {options.map(([value, id, label, note]) => (
                      <label
                        key={id}
                        htmlFor={`kb-folder-delete-${id}`}
                        className={`flex gap-3 p-3 border rounded-lg cursor-pointer ${
                          deleteFolderFiles === value
                            ? value
                              ? "border-[#B42318] bg-[#FEF3F2]"
                              : "border-[#A04A97] bg-[#FBF3FA]"
                            : "border-[#D4D4D8] bg-white hover:bg-[#FAFAFA]"
                        }`}
                      >
                        <input
                          id={`kb-folder-delete-${id}`}
                          type="radio"
                          name="kb-folder-delete"
                          checked={deleteFolderFiles === value}
                          disabled={isDeletingFolder}
                          onChange={() => setDeleteFolderFiles(value)}
                          className={`mt-[3px] ${value ? "accent-[#B42318]" : "accent-[#A04A97]"}`}
                        />
                        <span className="flex-1 min-w-0 flex flex-col gap-[2px]">
                          <span className={`text-[14px] font-semibold ${value ? "text-[#B42318]" : "text-[#18181B]"}`}>
                            {label}
                          </span>
                          <span className="text-[13px] leading-[1.45] text-[#3F3F46]">{note}</span>
                        </span>
                      </label>
                    ))}
                  </div>
                )}
                {n > 0 && deleteFolderFiles && (
                  <div className="flex flex-col gap-1 min-h-0">
                    {inOtherFolders > 0 && (
                      <p className="m-0 text-[13px] text-[#7A5B00]">
                        {inOtherFolders === 1
                          ? "1 of these files is also in another folder and will be removed from it too."
                          : `${inOtherFolders} of these files are also in other folders and will be removed from them too.`}
                      </p>
                    )}
                    <ul className="m-0 p-0 list-none max-h-[160px] overflow-y-auto custom-scrollbar border border-[#E4E4E7] rounded-md bg-[#FAFAFA] divide-y divide-[#E4E4E7]">
                      {docs.map((d) => (
                        <li key={d.id} title={d.name} className="px-3 py-[6px] text-[13px] text-[#27272A] truncate">
                          {d.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className="flex justify-end gap-[10px] mt-2">
                  <button
                    type="button"
                    disabled={isDeletingFolder}
                    onClick={() => setFolderToDelete(null)}
                    className="px-4 py-2 border border-[#A1A1AA] rounded-md bg-white text-[#27272A] text-[14px] font-medium disabled:opacity-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={isDeletingFolder}
                    onClick={async () => {
                      setIsDeletingFolder(true);
                      const done = await onDeleteFolder(folderToDelete, { deleteFiles: n > 0 && deleteFolderFiles, count: n });
                      setIsDeletingFolder(false);
                      if (done) setFolderToDelete(null);
                    }}
                    className="px-4 py-2 border border-[#B42318] rounded-md bg-[#B42318] hover:bg-[#912018] text-white text-[14px] font-medium disabled:opacity-50"
                  >
                    {isDeletingFolder
                      ? "Deleting..."
                      : n > 0 && deleteFolderFiles
                      ? `Delete folder and ${plural(n, "file")}`
                      : "Delete folder"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
    </div>
  );
};

export default AllSources;
